export default __webpack_public_path__ + "static/media/detail_big_13_1.29a40bd7.jpg";